import React from "react";
import { useParams } from "react-router";
import UploadVideoContainer from "../../containers/gallery/uploadVideo";

const UploadVideoPage = () => {
  const { id } = useParams();
  return id ? <UploadVideoContainer videoId={id} /> : <UploadVideoContainer />;
};

export default UploadVideoPage;